<template>
    <div>
        <div class="task">
            <div class="top flex-between">
                <div class="left_bar">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item><i class="iconfont icon-xueyuan-mulu" >&nbsp;班级任务</i></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div class="class_item" v-for="item in classMission" :key="item.id">
                <div class="flex-between class_content">
                    <div class="class_title">{{item.assignmentTitle}}</div>
                    <div class="time_wrap">完成时间：&nbsp;{{item.stopTime}}</div>
                </div>
                <div class="flex-between item_two">
                    <div class="item_two_left">
                        <div class="score_index">
                            <div>任务类型：{{item.evaluateType == 0 ? '手动评分':'自动评分'}}</div>
                            <div v-if="item.evaluateType != '0'">任务评分指标：{{item.evaluateIndex}}</div>
                        </div>
                        <div class="class_content brief">
                            <div class="flex-start tast_info">
                                <div>教师：{{item.teacherName}}</div>
                                <div>班级：{{item.className}}</div>
                                <div v-if="item.status == 3">得分：
                                    <span v-if="Number.isFinite(item.score)">{{item.score}}</span>
                                    <span v-else>--</span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="item.evaluateType == 1" class="flex-between item_two_right">
                        <div @click="toTaskDetail(item.assignmentId)">
                            <i class="el-icon-s-order"></i>
                            <div>查看任务详情</div>
                        </div>
                        <div> | </div>
                        <div @click="isOverdue(item)">
                            <el-upload
                                class="upload-demo"
                                :show-file-list="false"
                                :action="`${uploadCodeUrl+item.assignmentId}`"
                                :headers="{token:tokenVal}"
                                :disabled="item.status == 3"
                                :limit="1"
                                :on-success="uploadFile">
                                <div :style="item.status == 3?'color:#848484':''">
                                    <i class="iconfont icon-code"></i>
                                    <div>上传代码</div>
                                </div>
                            </el-upload>
                        </div>

                        <div> | </div>
                        <div :style="item.status == 3?'color:#848484':''" @click="uploadAnswer(item)">
                            <i class="iconfont icon-gongbudaan"></i>
                            <div>上传答案</div>
                        </div>
                    </div>
                    <div v-if="item.evaluateType == 0" class="flex-between  item_two_right">
                        <div @click="toTaskDetail(item.assignmentId)">
                            <i class="el-icon-s-order"></i>
                            <div>查看任务详情</div>
                        </div>
                        <div> | </div>
                        <div @click="isOverdue(item)">
                            <el-upload
                                class="upload-demo"
                                :show-file-list="false"
                                :action="`${uploadFileUrl+item.assignmentId}`"
                                :headers="{token:tokenVal}"
                                :disabled="item.status == 3"
                                :limit="1"
                                :on-success="uploadFile">
                                <div :style="item.status == 3?'color:#848484':''">
                                    <i class="iconfont icon-gongbudaan"></i>
                                    <div>上传作业</div>
                                </div>
                            </el-upload>
                        </div>

                    </div>
                </div>
            </div>
            <div class="empty-wrap" v-if="classMission.length == 0">
                <img src="../../assets/img/offshelf.png" alt="">
            </div>
            <div class="paging_wrap" v-if="pages.totals > 3">
                <el-pagination  background :page-size="3" layout="prev, pager, next"  @current-change="getClassTask" :current-page.sync="pages.currentPage" :total="pages.totals"></el-pagination>
            </div>
        </div>
        <!-- 特别提示 -->
        <el-dialog title="特别提示"  :visible.sync="templateVisible"  width="35%"  center>
            <div class="dialog_wrap">
                <div class="icon_notice">
                    <i class="iconfont icon-gantanhao"></i>
                    <span>请确保上传的答案符合模板</span>
                </div>
                <div class="dialog_text">系统仅可对符合答案模版的答案文件执行自动评分，您可点击查看模版或选择继续上传文件。</div>
                <div class="table_wrap">
                    <el-table v-if="indexType == '0'" border :data="classifyTable" stripe :header-cell-style="$core.tableHeader">
                        <el-table-column  width="200" type="index" align="center" label="index"  ></el-table-column>
                        <el-table-column  :prop="isAuc ? 'probability':'label'" align="center" :label="isAuc?'probability':'label'"  ></el-table-column>
                    </el-table>
                    <el-table border v-if="indexType == '1'" :data="classifyTable" stripe :header-cell-style="$core.tableHeader">
                        <el-table-column  width="200" type="index" align="center" label="index"  ></el-table-column>
                        <el-table-column  prop="yPrediction" align="center" label="y_prediction"  ></el-table-column>
                    </el-table>
                </div>
                <div class="notice_text">
                    <div>注意：</div>
                    <div>仅可上传csv文件</div>
                </div>
                <div class="button_wrap flex-around">
                    <a v-if="indexType == '0'" :href="isAuc?'https://mssdk-docs.obs.cn-southwest-2.myhuaweicloud.com/msdata_point_mode/AUC%28%E5%AD%A6%E7%94%9F%29.csv':'https://mssdk-docs.obs.cn-southwest-2.myhuaweicloud.com/msdata_point_mode/%E5%88%86%E7%B1%BB%E6%8C%87%E6%A0%87%E6%A8%A1%E6%9D%BF.csv'"><el-button type="primary">查看模板</el-button></a>
                    <a v-if="indexType == '1'" href="https://mssdk-docs.obs.cn-southwest-2.myhuaweicloud.com/msdata_point_mode/%E5%9B%9E%E5%BD%92%E8%AF%84%E4%BB%B7%E6%8C%87%E6%A0%87%E6%A8%A1%E6%9D%BF%28%E5%AD%A6%E7%94%9F%29.csv"><el-button type="primary">查看模板</el-button></a>
                    <el-upload
                        class="upload-demo"
                        :show-file-list="false"
                        :action="`${uploadFileUrl+taskId}`"
                        :headers="{token:tokenVal}"
                        :limit="1"
                        :on-success="uploadFile">
                        <el-button type="primary" plain >上传答案</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
        <!-- 上传文件途径选择 -->
        <el-dialog :visible.sync="selecrWayVisible" width="35%" title="请选择上传方式" center>
            <div class="update_way">
                <div>
                    <el-upload
                        class="upload-demo"
                            :show-file-list="false"
                            :action="`${uploadFileUrl+taskId}`"
                            :headers="{token:tokenVal}"
                            :limit="1"
                            :on-success="uploadFile">
                        <i class="el-icon-folder-opened"></i>
                        <div>从本地文件选择</div>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { classAssignment } from '../../utils/api';

export default {
    data() {
        return {
            taskId: '',
            tokenVal: sessionStorage.getItem('token'),
            uploadFileUrl: this.$config.SYSTEM_URL + `/msdata/assignment/student/uploadFile?assignmentId=`,
            uploadCodeUrl: this.$config.SYSTEM_URL + `/msdata/assignment/student/uploadCode?assignmentId=`,
            pages: {
                currentPage: 1,
                totals: 1
            },
                classMission:[],
                classifyTable:[{
                    probability:'0.1243',
                    label:'0',
                    yPrediction:'3.1654'
                },{
                    probability:'0.2671',
                    label:'1',
                    yPrediction:'2.371'
                },{
                    probability:'0.8764',
                    label:'0',
                    yPrediction:'4.389'
                }],
                templateVisible:false,
                selecrWayVisible:false,
                isAuc:'',
                indexType:''
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
            this.getClassTask()
        },
        methods: {
            //校验上传答案时，任务是否过期
            isOverdue(content){
                if(content.status == 3) return this.$message.error('实验任务已结束！！')
            },

            //上传文件，如果状态为3，则任务已结束
            uploadAnswer(content){
                if(content.status == 3) return this.$message.error('实验任务已结束！！')
                 this.taskId = content.assignmentId,
                 //判断指标中是否包含auc文件，分类指标模板中auc文件与其它文件模板不一致
                 this.isAuc = content.evaluateIndex.includes('AUC')
                 this.indexType = content.indexType
                 this.templateVisible = true
            },

            //查看文件模板后确认上传文件
            sureUpload(){
                this.templateVisible = false,
                this.selecrWayVisible = true
            },

            //去任务详情
            toTaskDetail(id){
                this.$router.push(`/taskDetail?taskId=${id}`)
            },

            //文件上传成功时的回调函数
            uploadFile(res, file) {
                if(res.status != 200) return this.$message.error(res.message)
                this.$message.success('文件上传成功')
                this.templateVisible = false
            },

            //上传文件时文件限制个数
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`);
            },

            //获取班级任务
            getClassTask(){
                let params = {
                    keyword:'',
                    page:this.pages.currentPage,
                    size:3
                }
                classAssignment(params).then(res => {
                    this.classMission = res.data.list;
                    this.pages.totals = res.data.totalCount;
                }).catch(err=>{})
            },
        }
    }
</script>

<style lang="scss" scoped>
.empty-wrap{
    background: white;
    margin-top: 10px;
}
.update_way{
    display: flex;
    justify-content: space-around;
    padding: 50px 0px;
    >div{
        width: 170px;
        height: 170px;
        border: 3px solid #999999;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-size: 18px;
        i{
            font-size: 50px;
            margin-bottom: 10px;
        }
    }
    >div:hover{
        color: #5277F7;
        border: 3px solid  #5277F7;
        cursor: pointer;
    }
}
.dialog_wrap{
    .icon_notice{
        font-size: 22px;
        color: #333;
        text-align: center;
        margin-bottom: 30px;
        i{
            color: #5277F7;
            font-size: 20px;
            margin-right: 5px;
        }
    }
    .dialog_text{
        font-size: 17px;
        color: #333;
        line-height: 1.8;
        // text-indent: 2rem;
    }
    .notice_text{
        color: #FD4B5E;
        line-height: 1.5;
        font-size: 18px;
    }
    .table_wrap{
        margin: 10px 0px;
    }
    .button_wrap{
        margin-top: 35px;
    }
}
.paging_wrap{
    margin-top: 20px;
    height: 60px;
    text-align: center;
}
.top{
    height: 55px;
    box-sizing: border-box;
    background: white;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 0px 50px 0px 0px;
    color: #848484;
    .icon-shoucangjia,.icon-xianxingwenjianjia{
        margin-right: 5px;
        font-size: 18px;
    }
    .icon-arrowLeft:hover{
        color: #5277F7;
    }
    .icon-xianxingwenjianjia:hover{
        color: #FEA757;
    }
    .left_bar{
        min-width: 100px;
        // max-width: 250px;
        /deep/.el-breadcrumb__inner{
            line-height: 55px;
            font-size: 17px;
            color: white;
        }
        .icon-shoucangjia{
            color: white;
        }
        height: 55px;
        padding: 0px 50px;
        background: url(../../assets/img/collectBar.png) 0 0/100% 100% no-repeat;
    }
}
.class_item{
    background: white;
    padding: 30px 110px 30px 80px;
    margin: 10px 0px;
    color: #848484;
    .time_wrap{
        color: #FF4D00;
        font-size: 18px;
    }
    .score_index{
        line-height: 1.8;
        font-weight: bold;
        font-size: 18px;
        font-family: PingFang SC;
    }
    .item_two_right{
        text-align: center;
        color: #5277F7;
        font-size: 16px;
        i{
            font-size: 20px;
        }
        >div{
            margin: 0px 15px;
        }
        >div:hover{
            color: #FF4D00;
            cursor: pointer;
        }
    }
    .class_content{
        line-height: 2;
    }
    .tast_info{
        div{
            margin-right: 40px;
        }

        // width: 60%;
    }
    .brief{
        min-width: 30vw;
    }
    .item_two{
        font-size: 20px;
    }
    .class_title{
        color: #3C3C3C;
        height: 60px;
        line-height: 60px;
        font-size: 26px;
        font-weight: 600;
    }
}
.task{
    min-height: 500px;
}
/deep/.el-tabs__nav-scroll{
    background: white;
    padding: 10px 0px 5px 10px;
    margin-top: 15px;
}
</style>

